import classnames from 'classnames';
import type {
  SavedSearchParameters,
  SearchFilterField,
} from 'lib-shared-types-api';
import isEmpty from 'lodash/isEmpty';

import { convertSortObjectToString } from '../../../utils/sort/convertSort';
import { sortOptions } from '../../results/components/sort/searchResultsSort';

import { SavedSearchFiltersCondition } from './components/condition/savedSearchFiltersCondition';
import { SavedSearchFiltersItem } from './components/item/savedSearchFiltersItem';
import styles from './savedSearchFilters.module.scss';

export type SavedSearchFiltersProps = {
  variant: 'text' | 'chips';
  params: SavedSearchParameters;
  onRemove?: (field: 'query' | SearchFilterField, index: number) => void;
};

export const SavedSearchFilters = ({
  variant,
  params: { query, filters, strict, sort },
  onRemove,
}: SavedSearchFiltersProps): JSX.Element => {
  const rootClass = classnames(styles.filters, {
    [styles.filtersText]: variant === 'text',
    [styles.filtersChips]: variant === 'chips',
  });

  return (
    <div className={rootClass}>
      {query && (
        <>
          <SavedSearchFiltersItem
            variant={variant}
            label="Keyword"
            value={query}
            onDelete={
              isEmpty(filters?.conditions)
                ? undefined
                : () => onRemove?.('query', -1)
            }
          />

          <SavedSearchFiltersItem
            variant={variant}
            label="Exact match"
            value={strict ? 'Enabled' : 'Disabled'}
          />
        </>
      )}

      <SavedSearchFiltersItem
        variant={variant}
        label="Sort by"
        value={
          (sort &&
            sortOptions.find(
              ({ value }) => value === convertSortObjectToString(sort),
            )?.label) ||
          'Relevance'
        }
      />

      {filters?.conditions.map((condition, index) => (
        <SavedSearchFiltersCondition
          key={`${condition.field}-${index}`}
          variant={variant}
          condition={condition}
          onDelete={() => onRemove?.(condition.field, index)}
        />
      ))}
    </div>
  );
};
